import { z } from 'zod'

/**
 * 服務檔案 Schema
 */
export const serviceFileDataSchema = z.object({
  /** 問題答覆附件檔案ID */
  sfID: z.number(),
  /** 問題答覆紀錄ID */
  slID: z.number(),
  /** 編譯過的檔案名稱 */
  fileName: z.string(),
  /** 上傳的檔名 */
  uploadName: z.string(),
  /** 副檔名 */
  extension: z.string(),
  /** 檔案大小 */
  fileSize: z.number(),
  /** 修改日期 */
  modifyDate: z.string(),
  /** 修改者 */
  modifyUser: z.string()
})

/**
 * 服務檔案
 */
export interface ServiceFileData
  extends z.infer<typeof serviceFileDataSchema> {}
